import { render, staticRenderFns } from "./Subscriptions-Invoices.vue?vue&type=template&id=6510d81e&"
import script from "./Subscriptions-Invoices.vue?vue&type=script&lang=js&"
export * from "./Subscriptions-Invoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports